import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";

interface eventState {
  updateEventBody: {};
  allSlots: {};
}

const initialState: eventState = {
  updateEventBody: {},
  allSlots: {},
};

const updateEventSlice = createSlice({
  name: "updateEvent",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(updateEvent.fulfilled, (state, action) => {
        state.updateEventBody = action.payload;
      })
      .addCase(allSlots.fulfilled, (state, action) => {
        state.allSlots = action.payload;
      });
  },
});

export default updateEventSlice.reducer;

export const updateEvent = createAsyncThunk(
  "events/updateEvent",
  async (data: any) => {
    const dataEvent = data.get("event");
    const dataValue = JSON.parse(dataEvent);
    const response = await axiosInstance.put(
      `api/events/admin/updateEventById/${dataValue.id}`,
      data
    );
    return response.data;
  }
);
export const allSlots = createAsyncThunk(
  "events/getSlotsData",
  async (slotData: any) => {
    const response = await axiosInstance.get(
      `/api/events/getSlotsData/eventId/${slotData.id}/allSlots/${slotData.allslots}`
    );
    return response.data;
  }
);
